<template>
  <section ref="threeContainer" id="threeContainerID" class="three-page-section media_section_height">
    <div class="media_screen_style">
      <div style="color: #fff6f6; font-size: 32px; margin-bottom: 16px" class="shake2">
        {{ t("three.title") }}
      </div>
      <div style="color: #fef8f8; font-size: 16px; margin-bottom: 32px;">
        {{ t("three.details") }}
      </div>
      <div class="three_img_bg">
        <QrPage class="three_img_one" :class="{ animate: hasAnimated }" />
        <!-- <img  class="three_img_one" :class="{ animate: hasAnimated }" src="../assets/2.png" alt="" /> -->

        <img class="three_img_two" :class="{ animate: hasAnimated }" :src="imgs[lang]" alt="" />
      </div>
      <div style="height: 720px;"></div>
      <div ref="textContainer" id="textContainerID" :class="{ animate: hasTextAnimated }" class="qr_text">
        {{ t("three.bottomtext") }}
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, defineEmits, defineExpose } from "vue";
import QrPage from "./QrPage.vue";
const threeContainer = ref(null);
const hasAnimated = ref(false);
const hasTextAnimated = ref(false);
const textContainer = ref(null);
const emit = defineEmits(['notify'])

import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();

const lang = ref("zh");
if (locale.value != 'zh-CN' && locale.value != 'zh') {
  lang.value = "en";
}
const imgs = {
  zh: new URL('@/assets/2.webp', import.meta.url).href,
  en: new URL('@/assets/2_en.webp', import.meta.url).href,
};
onMounted(() => {
  const observer = new IntersectionObserver(
    (entry) => {
      entry.forEach((item => {
        const el = item.target;

        if (item.isIntersecting && !hasAnimated.value && el.id === 'threeContainerID') {
          emit('notify', item.isIntersecting);
          setTimeout(() => {
            //   isFading.value = true;
            hasAnimated.value = true;
          }, 1000);
        }
        if (item.isIntersecting && !hasTextAnimated.value && el.id === 'textContainerID') {
          setTimeout(() => {
            //   isFading.value = true;
            hasTextAnimated.value = true;
          }, 500);
        }
        if (hasAnimated.value && hasTextAnimated.value) {
          observer.disconnect();
        }
      }))
      // if (entry.isIntersecting && !hasAnimated.value) {
      //   setTimeout(() => {
      //     //   isFading.value = true;
      //     hasAnimated.value = true;
      //   }, 1000);
      //   observer.disconnect();
      // }
    },
    {
      threshold: 0.5,
    }
  );

  if (threeContainer.value) {
    observer.observe(threeContainer.value);
  }
  if (textContainer.value) {
    observer.observe(textContainer.value);
  }
});

const test = () => {
  threeContainer.value.scrollIntoView({
    top: top,
    behavior: 'smooth'

  });

}


// 暴露给父组件
defineExpose({
  test
});
</script>

<style scoped>
.three-page-section {
  /* transform: scale(.7);
  transform-origin: top; */
  /* height: 100vh; */
  text-align: center;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  margin-top: 32px;
  /* min-height: 932px; */
}

.three_img_bg {
  position: relative;
}

.three_img_one {
  position: absolute;
  top: 20px;
  right: 50%;
  transform: translateX(50%);

}

/* 动画关键帧 */
@keyframes appearDownLeftOne {
  0% {
    transform: translateX(50%) scale(1);
    /* width: 300px;
    height: 666px; */
    transform-origin: center center;
  }

  40% {
    transform: translateX(50%) scale(0.833);
    transform-origin: center center;
    /* width: 250px;
    height: 555px; */
  }

  70% {
    transform-origin: center center;
    /* width: 250px;
    height: 555px; */
    transform: translateX(50%) translateY(-50px) scale(0.833);
    /* 先向下 */
  }

  100% {
    transform-origin: center center;
    /* width: 250px;
    height: 555px; */
    transform: translateX(calc(50% - 50px)) translateY(-50px) scale(0.833);
    /* 再向左 */
  }
}

/* 应用动画 */
.three_img_one.animate {
  animation: appearDownLeftOne 2s cubic-bezier(0.65, 0, 0.35, 1.35) forwards;
}

.three_img_two {
  position: absolute;
  top: 20px;
  right: 50%;
  transform: translateX(50%);
  transform-origin: center;
  width: 300px;
}

/* 动画关键帧 */
@keyframes appearDownLeftTwo {
  0% {
    transform-origin: center center;
    transform: translateX(50%) scale(1);
    /* width: 300px; */
  }

  40% {
    transform-origin: center center;
    transform: translateX(50%) scale(0.833);
    /* width: 250px; */
  }

  70% {
    transform-origin: center center;
    /* width: 250px; */
    transform: translateX(50%) translateY(50px) scale(0.833);
    /* 先向下 */
  }

  100% {
    transform-origin: center center;
    /* width: 250px; */
    transform: translateX(calc(50% + 50px)) translateY(50px) scale(0.833);
    /* 再向左 */
  }
}

/* 应用动画 */
.three_img_two.animate {
  animation: appearDownLeftTwo 2s cubic-bezier(0.65, 0, 0.35, 1.35) forwards;
}

.qr_text {
  opacity: 0;
}

@keyframes qrTextBounce {

  0%,
  100% {
    /* font-size: 14px;    */
    opacity: 1;
  }

  50% {
    /* font-size: 16px; */
    opacity: 0;
  }
}

.qr_text {
  animation: qrTextBounce 0.6s forwards;
}
</style>
